import hooksConstants from 'src/constants/hooks.constants';
import AuthService from 'src/services/api/auth.service';
import { useGetFeedbackQuery } from 'src/store/api/insights';
import {
  findInsightByContentBk,
  findInsightByLessonKey,
} from 'src/utils/feedback.utils';

export const useFeedback = (
  contentOrCardstackKey?: string,
  lessonKey?: string,
) => {
  const userBk = AuthService.getUserBk();
  const isTeacher = AuthService.isTeacher();

  const { isLoading, data: feedbackData } = useGetFeedbackQuery(userBk, {
    skip: isTeacher || (!contentOrCardstackKey && !lessonKey),
    pollingInterval: hooksConstants.INSIGHTS_POLLING_INTERVAL,
  });

  // search by lessonKey for k-5 lessons assigned on Curriculum
  const feedback = lessonKey
    ? findInsightByLessonKey(lessonKey, feedbackData)
    : findInsightByContentBk(contentOrCardstackKey, feedbackData);

  return { feedback, feedbacksCount: feedbackData?.length, isLoading };
};
